import {
  Component,
  Inject,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';



interface AdminData {
  title: string;
  message: string;
  adding: boolean;
}

@Component({
  standalone: false,
  selector: 'app-confirm-company-admin-dialog',
  templateUrl: './confirm-company-admin-dialog.component.html',
  styleUrls: ['./confirm-company-admin-dialog.component.scss']
})
export class ConfirmCompanyAdminDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AdminData,
  ) {}
}
